import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListItemSelectedIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 9.0979L5.71795 13.1538L14.0833 2",
		stroke: "#1377E7",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgListItemSelectedIcon;
